import { PLATFORM } from 'aurelia-pal';
import { Search } from './services/search.service';

const searchSectionComponent = PLATFORM.moduleName('./components/searchSection/searchSection');
const searchResultsComponent = PLATFORM.moduleName('./components/searchResults/searchResults');

export const configure = (aurelia) => {
  // Services
  aurelia.container.registerSingleton('search', Search);

  // Components
  aurelia.globalResources(
    searchSectionComponent,
    searchResultsComponent,
  );
};
